'use client'

import { getCartItems } from '@/lib/cart/server'
import type { serviceType } from '@/lib/service/server'
import {
  faShoppingBag,
  faShoppingCart,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useEffect, useState } from 'react'

type CartIconProps = {
  service: serviceType
  bag?: boolean
}

export const CartIconClient: React.FC<CartIconProps> = ({ service, bag }) => {
  const [count, setCount] = useState(0)
  useEffect(() => {
    let cancelled = false
    getCartItems(service.service_id)
      .then((items) => {
        if (!cancelled) setCount(items?.length ?? 0)
      })
      .catch(() => {
        if (!cancelled) setCount(0)
      })
    return () => {
      cancelled = true
    }
  }, [service.service_id])
  return (
    <div className="w-full relative">
      <FontAwesomeIcon
        icon={bag ? faShoppingBag : faShoppingCart}
        fontSize={'20px'}
        className=""
      />
      <span
        className="absolute rounded-full bg-red-500 text-white text-xs px-1"
        style={{ right: '-7px', top: '-6px' }}
      >
        {count}
      </span>
    </div>
  )
}
